import React, { Component } from "react";
import { Box } from "rebass";

import {
  BanksField,
  CategoryField,
  DetailsField,
  SocialField,
} from "../MarketerField";

class FormMain extends Component {
  // constructor(props) {
  //   super(props);
  // }
  render() {
    const {
      children,
      record,
      resource,
      basePath,
      translate,
      permissions,
      updateField,
    } = this.props;
    return (
      <Box w={[1]}>
        {DetailsField(
          children.props.children,
          record,
          resource,
          basePath,
          translate,
          updateField
        )}
        {permissions === "Admin" &&
          BanksField(
            children.props.children,
            record,
            resource,
            basePath,
            translate
          )}
        {SocialField(
          children.props.children,
          record,
          resource,
          basePath,
          translate,
          this.props
        )}
        {CategoryField(
          children.props.children,
          record,
          resource,
          basePath,
          translate
        )}
      </Box>
    );
  }
}

export default FormMain;



// WEBPACK FOOTER //
// ./src/marketers/form/FormMain.js